import { render, staticRenderFns } from "./ChartsPie.vue?vue&type=template&id=1d507b1d&scoped=true&"
import script from "./ChartsPie.vue?vue&type=script&lang=js&"
export * from "./ChartsPie.vue?vue&type=script&lang=js&"
import style0 from "./ChartsPie.vue?vue&type=style&index=0&id=1d507b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d507b1d",
  null
  
)

export default component.exports